import React, { useContext } from "react";
import styles from "./Map.module.scss";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";

import BuildingContext from "../../context/building";
import { useState } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import Building from '../Building/Building';
import Factoid from '../Factoid';
import Figure from '../Figure';
const Map = () => {
  const path = useContext(PathContext);
  const isMobile = useContext(MobileContext);
  const [activeTab, setActiveTab] = useState(0);
  const [activeBuilding, setActiveBuilding] = useState(-1);
  const [init, setInit] = useState(false);
  const [data, setData] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [popupActivePage, setPopupActivePage] = useState(0);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupColor, setPopupColor] = useState('');
  const [popupType, setPopupType] = useState('');
  const [popupLocation, setPopupLocation] = useState('');

  const refPopup = useRef(null);
  const refOverlay = useRef(null);
  const refWrap = useRef(null);
  const refOverlayWrap = useRef(null);
  const refPopupWrap = useRef(null);
  const refClose = useRef(null);
  const updateActiveBuilding = (number) => {
    setOpenPopup(true);
    return setActiveBuilding(number);
  }
  const closePopup = () => {
    setOpenPopup(false);

  }


  useEffect(() => {
    fetch(`${path}/data/buildings.json`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // console.log(data);
        setData(data);
        setInit(true);
      });
  }, [path]);

  useEffect(() => {
    if (activeBuilding !== -1 && init) {
      setPopupActivePage(0);
      setPopupTitle(data[activeBuilding].title);
      setPopupLocation(data[activeBuilding].location);
      setPopupColor(data[activeBuilding].color);

    }
  }, [activeBuilding, data, init]);

  useEffect(() => {
    const popup = refPopup.current;
    const overlay = refOverlay.current;
    const wrapOver = refOverlayWrap.current;
    const wrapPopup = refPopupWrap.current;
    const close = refClose.current;
    const toggleScroll = (bool) => {
      if (bool) {
        document.body.style.overflow = 'hidden';
        document.body.style.pointerEvents = 'none';

      } else {
        document.body.style.overflow = '';
        document.body.style.pointerEvents = '';
      }
    }
    if (isMobile) {
      if (!Array.from(document.body.childNodes).includes(overlay)) {
        document.body.appendChild(overlay);
      }
      if (!Array.from(document.body.childNodes).includes(popup)) {
        document.body.appendChild(popup);
      }

    } else {
      if (Array.from(document.body.childNodes).includes(popup)) {
        document.body.removeChild(popup);
        wrapPopup.appendChild(popup);
      }
      if (Array.from(document.body.childNodes).includes(overlay)) {
        document.body.removeChild(overlay);
        wrapOver.appendChild(overlay);
      }
    }
    if (openPopup) {
      if (isMobile) {
        toggleScroll(true);
      } else {
        document.body.style.overflow = 'hidden';
      }
      popup.scrollTop = 0;
      overlay.classList.add(styles.active);
      popup.classList.add(styles.active);
    } else {
      if (isMobile) {
        toggleScroll(false);
      } else {
        document.body.style.overflow = '';
      }
      overlay.classList.remove(styles.active);
      popup.classList.remove(styles.active);
    }
    close.addEventListener('click', closePopup);
    return () => {
      document.body.style.overflow = '';
      if (Array.from(document.body.childNodes).includes(popup)) {
        document.body.removeChild(popup);
        wrapPopup.appendChild(popup);
      }
      if (Array.from(document.body.childNodes).includes(overlay)) {
        document.body.removeChild(overlay);
        wrapOver.appendChild(overlay);
      }
      toggleScroll(false);
      close.removeEventListener('click', closePopup);
    }
  }, [isMobile, openPopup]);

  const factoidHandler = (array) => {
    let result = [];
    array.forEach((element, index) => {
      let factoid = <div className={styles.popup__factoid} key={`factoid-${index}`}><Factoid color={popupColor} title={element.header} text={element.text} size={'small'} /></div>;
      result.push(factoid);
    });
    return <div className={styles.popup__factoids} key={`factoids`}>{result}</div>;
  }
  const figureHandler = (array) => {
    let result = [];
    result[0] = <div className={styles.popup__figure} key={`figure-0`}> <span>{array[0]}</span> </div>;
    result[1] = <div className={styles.popup__figure} key={`figure-1`}>
      <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.9" d="M27 4.56922L33.9664 1L38.2149 7.57354L46.0326 7.96643L46.4255 15.7841L53 20.0336L49.4308 27L53 33.9664L46.4255 38.2149L46.0326 46.0326L38.2149 46.4255L33.9664 53L27 49.4308L20.0336 53L15.7841 46.4255L7.96643 46.0326L7.57354 38.2149L1 33.9664L4.56922 27L1 20.0336L7.57354 15.7841L7.96643 7.96643L15.7841 7.57354L20.0336 1L27 4.56922Z" stroke="#003333" strokeWidth="1.5" strokeMiterlimit="10" />
      </svg>
    </div>;
    result[2] = array[1] !== "" ? <div className={styles.popup__figure} key={`figure-2`}><span>{array[1]}</span></div> : null;
    result[3] = <div className={styles.popup__figure} key={`figure-3`}><span>{array[2]}</span></div>;
    result[4] = <div className={styles.popup__figure} key={`figure-4`}>
      <svg width="56" height="55" viewBox="0 0 57 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.3799 51.0341L3.93026 34.5847C2.05302 32.6942 1 30.1415 1 27.4813C1 24.8212 2.05302 22.2685 3.93026 20.378L20.3799 3.92579C22.2671 2.05203 24.8221 1 27.4856 1C30.1492 1 32.7042 2.05203 34.5914 3.92579L51.0382 20.3836C51.9769 21.3148 52.7218 22.4217 53.2301 23.6407C53.7383 24.8597 54 26.1669 54 27.487C54 28.8071 53.7383 30.1143 53.2301 31.3333C52.7218 32.5523 51.9769 33.6592 51.0382 34.5904L34.6055 51.0341C33.6761 51.9735 32.5688 52.7195 31.3477 53.2287C30.1267 53.7378 28.8163 54 27.4927 54C26.1692 54 24.8588 53.7378 23.6378 53.2287C22.4167 52.7195 21.3093 51.9735 20.3799 51.0341V51.0341Z" stroke="#003333" strokeWidth="1.5" strokeMiterlimit="10" />
      </svg>
    </div>;

    return <div className={styles.popup__figures} key={`figures`}>{result}</div>;
  }

  const cityHandler = (array) => {
    let result = array.map((element, index) => {
      return <div className={styles.popup__col} key={`col-${index}`}>
        {element.map((elem, i) => {
          if (elem !== null) {
            return <span key={`city-${i}`}>{elem}</span>
          } else {
            return <span className={styles.popup__border} key={`city-${i}`}></span>
          }
        })}
      </div>
    });
    return <div className={styles.popup__city} key={`cities`}>{result}</div>;
  }

  const textHandler = (array) => {
    let result = [];
    array.forEach((element, index) => {

      let item = null;
      for (let prop in element) {
        switch (prop) {
          case 'p':
            item = <p key={`text-${index}`}>{element[prop]}</p>
            break;
          case 'ul':
            let list = element[prop].map((elem, i) => {
              return <li key={`li-${i}`}>{elem}</li>
            });
            item = <ul key={`ul-${index}`}>{list}</ul>;
            break;

          default:
            break;
        }
      }
      result.push(item);
    });
    return <div className={styles.popup__texts} key={`texts`}>{result}</div>;
  }

  let popupPages = [];
  let popupPagination = [];
  let imgPopup = null;
  if (activeBuilding !== -1 && data[activeBuilding] !== undefined && init) {
    popupPages = data[activeBuilding].pages.map((element, index) => {
      let pageInner = [];
      for (let prop in element) {
        switch (prop) {
          case 'factoid':
            pageInner.push(factoidHandler(element[prop]));
            break;
          case 'text':
            pageInner.push(textHandler(element[prop]));
            break;
          case 'figure':
            pageInner.push(figureHandler(element[prop]));
            break;
          case 'city':
            if(!isMobile){
            pageInner.push(cityHandler(element[prop]));
            }
            break;
          case 'cityMobile':
            if(isMobile){
            pageInner.push(cityHandler(element[prop]));
            }
            break;

          default:
            break;
        }
      }

      popupPagination.push(<div className={styles.popup__point} key={`point-${index}`} onClick={() => { setPopupActivePage(index) }}></div>);
      return <div className={styles.popup__page} key={`pages-${index}`}>{pageInner}</div>
    });
    imgPopup = <picture>
      <img src={`${path}/img/buildings/building-popup-${activeBuilding}.webp`}  style={{ "opacity": 0 }} onLoad={(e) => { e.target.style.opacity = 1; e.target.style.transition = 'opacity ease 0.1s' }} alt="" />
    </picture>;
  }
  let popupInnerClass = `${styles.popup__inner}`;
  if (styles[`popup__inner_${popupActivePage}`] !== undefined) {
    popupInnerClass += ` ${styles[`popup__inner_${popupActivePage}`]}`;
  }
  if (styles[`popup__inner_${popupType}`] !== undefined) {
    popupInnerClass += ` ${styles[`popup__inner_${popupType}`]}`;
  }

  let popupClass = `${styles.popup}`;
  if (styles[`popup_${activeBuilding}`] !== undefined) {
    popupClass += ` ${styles[`popup_${activeBuilding}`]}`;
  }
  let linkClass = `${styles.link}`;
  if(isMobile){
    linkClass = `${styles.link} ${styles.mobile}`;
  }
  return (

    <BuildingContext.Provider value={{ 'updateActiveBuilding': updateActiveBuilding }}>

      <div className={styles.overlay_wrap} ref={refOverlayWrap}>
        <div className={styles.overlay} ref={refOverlay} onClick={closePopup}>

        </div>
      </div>
      <div className={styles.popup_wrap} ref={refPopupWrap}>
        <div className={styles.popup_wrapper} ref={refPopup}>
          <div className={styles.popup_container}>
            <div className={popupClass}>
              <div className={styles.popup__close} ref={refClose}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.1275 1.3415L6.82275 5.64628L6.4692 5.99984L6.82275 6.35339L11.1275 10.6582L10.6596 11.1261L6.35486 6.82128L6.0013 6.46773L5.64775 6.82128L1.34297 11.1261L0.875076 10.6582L5.17986 6.35339L5.53341 5.99984L5.17986 5.64628L0.875076 1.3415L1.34297 0.873611L5.64775 5.17839L6.0013 5.53194L6.35486 5.17839L10.6596 0.873611L11.1275 1.3415Z" fill="#003333" stroke="#003333" />
                </svg>
              </div>
              <div className={styles.popup__img} key={`popup-img-${activeBuilding}`}>
                {imgPopup}
              </div>

              <div className={popupInnerClass}>
                <div className={styles.popup__title}>{popupTitle}</div>
                <div className={styles.popup__location}>
                  <div className={styles.popup__icon}>
                    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 0C2.68286 0 0 2.817 0 6.3C0 11.025 6 18 6 18C6 18 12 11.025 12 6.3C12 2.817 9.31714 0 6 0ZM6 8.55C4.81714 8.55 3.85714 7.542 3.85714 6.3C3.85714 5.058 4.81714 4.05 6 4.05C7.18286 4.05 8.14286 5.058 8.14286 6.3C8.14286 7.542 7.18286 8.55 6 8.55Z" fill="#BFBFBF" />
                    </svg>
                  </div>
                  {popupLocation}
                </div>
                <div className={`${styles.popup__pages} ${styles[`popup__pages_${popupActivePage}`]}`}>
                  {popupPages}
                </div>

              </div>
              <div className={`${styles.popup__pagination} ${styles[`popup__pagination_${popupActivePage}`]}`}>
                {popupPagination}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.wrap} ${styles[`wrap_${activeTab}`]}`}>
        <div className={styles.header}>
          <div className="container">
            <div className={styles.header__inner}>
              <h2 className={styles.title}>Площадки и компании Р-Фарм</h2>
              <div className={styles.menu}>
                <div className={linkClass} onClick={() => { setActiveTab(0) }}>В России</div>
                <div className={linkClass} onClick={() => { setActiveTab(1) }}>За рубежом</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.info}>Нажмите на объект, чтобы узнать больше</div>
        <div className={styles.tabs}>
          <div className={styles.tab}>
            
          <div className={styles.tab__labels}>
              <div className={`${styles.label} ${styles.label_9}`}>
                <span>Ростовский завод</span> 
              </div>
              <div className={`${styles.label} ${styles.label_10}`}>
                <span>Завод</span> 
                <span>Р-Фарм Прогресс</span>
              </div>
              <div className={`${styles.label} ${styles.label_11}`}>
                <span>Ярославский завод </span> 
                <span>Р-Фарм</span>
              </div>
              <div className={`${styles.label} ${styles.label_12}`}>
                <span>Завод</span> 
                <span>Р-Фарм Новосёлки</span>
              </div>
              <div className={`${styles.label} ${styles.label_13}`}>
                <span>Завод «ЭкоСтиль»</span>
              </div>
              <div className={`${styles.label} ${styles.label_14}`}>
                <span>Завод Р-Фарм</span> 
                <span>в Зеленограде</span>
              </div>
              <div className={`${styles.label} ${styles.label_15}`}>
                <span>Штаб-квартира</span>
              </div>
              <div className={`${styles.label} ${styles.label_16}`}>
                <span>Фабрика</span> 
                <span>радиотерапевтической</span>
                <span>техники</span>
              </div>
              <div className={`${styles.label} ${styles.label_17}`}>
                <span>Компания</span> 
                <span>Р-Фарм Косметикс</span>
              </div>
              <div className={`${styles.label} ${styles.label_18}`}>
                <span>Компания</span> 
                <span>Р-Фарм ИТ</span>
              </div>
              <div className={`${styles.label} ${styles.label_19}`}>
                <span>Компания</span> 
                <span>«Альбиоген»</span>
              </div>
              <div className={`${styles.label} ${styles.label_20}`}>
                <span>Логистический комплекс</span> 
                <span>«Север»</span>
              </div>
              <div className={`${styles.label} ${styles.label_21}`}>
                <span>Завод «ОРТАТ»</span>
              </div>
              <div className={`${styles.label} ${styles.label_22}`}>
                <span>Компания</span> 
                <span>«Рисерч Лаб»</span>
              </div>
              <div className={`${styles.label} ${styles.label_23}`}>
                <span>Завод</span> 
                <span>«Спутник Технополис»</span>
              </div>
              <div className={`${styles.label} ${styles.label_24}`}>
                <span>Компания</span> 
                <span>«Технология лекарств»</span>
              </div>
              <div className={`${styles.label} ${styles.label_25}`}>
                <span>Компания</span> 
                <span>«АрПи Канон Медикал</span>
                <span>Системз»</span>
              </div>
              <div className={`${styles.label} ${styles.label_26}`}>
                <span>«Р-Фарм</span> 
                <span>Медицинские</span>
                <span>системы»</span>
              </div>
            </div>
            <div className={styles.tab__buildings}>
              <div className={`${styles.building} ${styles.building_0}`}>
                <Building index={0} />
              </div>
              <div className={`${styles.building} ${styles.building_1}`}>
                <Building index={1} />
              </div>
              <div className={`${styles.building} ${styles.building_2}`}>
                <Building index={2} />
              </div>
              <div className={`${styles.building} ${styles.building_3}`}>
                <Building index={3} />
              </div>
              <div className={`${styles.building} ${styles.building_4}`}>
                <Building index={4} />
              </div>
              <div className={`${styles.building} ${styles.building_5}`}>
                <Building index={5} />
              </div>
              <div className={`${styles.building} ${styles.building_6}`}>
                <Building index={6} />
              </div>
              <div className={`${styles.building} ${styles.building_7}`}>
                <Building index={7} />
              </div>
              <div className={`${styles.building} ${styles.building_8}`}>
                <Building index={8} />
              </div>
              <div className={`${styles.building} ${styles.building_12}`}>
                <Building index={12} />
              </div>
              <div className={`${styles.building} ${styles.building_13}`}>
                <Building index={13} />
              </div>
              <div className={`${styles.building} ${styles.building_14}`}>
                <Building index={14} />
              </div>
              <div className={`${styles.building} ${styles.building_15}`}>
                <Building index={15} />
              </div>
              <div className={`${styles.building} ${styles.building_16}`}>
                <Building index={16} />
              </div>
              <div className={`${styles.building} ${styles.building_17}`}>
                <Building index={17} />
              </div>
              <div className={`${styles.building} ${styles.building_18}`}>
                <Building index={18} />
              </div>
              <div className={`${styles.building} ${styles.building_19}`}>
                <Building index={19} />
              </div>
              <div className={`${styles.building} ${styles.building_20}`}>
                <Building index={20} />
              </div>
              {/* <object type="image/svg+xml" data={`${path}/img/map-buildings-1.svg`} onLoad={loading} ref={refMap1}> </object> */}
            </div>
            <div className={styles.tab__bg}>

              <picture>
                <source media="(min-width: 1921px)" srcSet={`${path}/img/map-bg-1@2x.webp`} />
                <source media="screen and (max-width: 767px)" srcSet={`${path}/img/map-bg-1-mobile.webp, ${path}/img/map-bg-1-mobile@2x.webp 2x`} />
                <img src={`${path}/img/map-bg-1.webp`} srcSet={`${path}/img/map-bg-1@2x.webp 2x`} alt=""  loading="lazy"/>
              </picture>
            </div>
          </div>

          <div className={styles.tab}>
            <div className={styles.tab__labels}>
              <div className={`${styles.label} ${styles.label_0}`}><span>Представительство</span> <span>Ташкент, Узбекистан</span></div>
              <div className={`${styles.label} ${styles.label_1}`}><span>Представительство</span> <span>Минск, Беларусь</span></div>
              <div className={`${styles.label} ${styles.label_2}`}><span>Представительство</span> <span>Алма-Ата, Казахстан</span></div>
              <div className={`${styles.label} ${styles.label_3}`}><span>Представительство</span> <span>Бишкек, Кыргызстан</span></div>
              <div className={`${styles.label} ${styles.label_4}`}><span>Представительство</span> <span>Сан-Диего, США</span></div>
              <div className={`${styles.label} ${styles.label_5}`}><span>Представительство</span> <span>Ханой, Вьетнам</span></div>
              <div className={`${styles.label} ${styles.label_6}`}><span>Завод Р-Фарм</span> <span>в Азербайджане</span></div>
              <div className={`${styles.label} ${styles.label_7}`}><span>R-Pharm Overseas</span></div>
              <div className={`${styles.label} ${styles.label_8}`}><span>Завод Р-Фарм</span> <span>в Германии</span></div>
            </div>
            <div className={styles.tab__buildings}>
              {/* <object type="image/svg+xml" data={`${path}/img/map-buildings-2.svg`} onLoad={loading} ref={refMap2}> </object> */}
              
              <div className={`${styles.building} ${styles.building_9}`}>
                <Building index={9} />
              </div>
              <div className={`${styles.building} ${styles.building_10}`}>
                <Building index={10} />
              </div>
              <div className={`${styles.building} ${styles.building_11}`}>
                <Building index={11} />
              </div>
              <div className={`${styles.building} ${styles.building_21}`}>
                <Building index={21} disable={true}/>
              </div>
              <div className={`${styles.building} ${styles.building_22}`}>
                <Building index={22} disable={true}/>
              </div>
              <div className={`${styles.building} ${styles.building_23}`}>
                <Building index={23} disable={true}/>
              </div>
              <div className={`${styles.building} ${styles.building_24}`}>
                <Building index={24} disable={true}/>
              </div>
              <div className={`${styles.building} ${styles.building_25}`}>
                <Building index={25} disable={true}/>
              </div>
              <div className={`${styles.building} ${styles.building_26}`}>
                <Building index={26} disable={true}/>
              </div>
              <div className={`${styles.building} ${styles.building_27}`}>
                <picture>
                <img src={`${path}/img/buildings/npc-building-1.webp`} alt="" />
              </picture>
              </div>
            </div>
            <div className={styles.tab__bg}>

              <picture>
                <source media="(min-width: 1921px)" srcSet={`${path}/img/map-bg-2@2x.webp`} />
                <source media="screen and (max-width: 767px)" srcSet={`${path}/img/map-bg-2-mobile.webp, ${path}/img/map-bg-2-mobile@2x.webp 2x`} />
                <img src={`${path}/img/map-bg-2.webp`} srcSet={`${path}/img/map-bg-2@2x.webp 2x`} alt=""  loading="lazy"/>
              </picture>
            </div>
          </div>
        </div>
      </div>
    </BuildingContext.Provider>
  );

}

export default Map;
